import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import {
  PoMenuItem,
  PoMenuModule,
  PoPageModule,
  PoToolbarAction,
  PoToolbarModule,
  PoToolbarProfile,
} from '@po-ui/ng-components';
import { TokenService } from '../../shared/service/token.service';
import { AuthService } from '../../shared/service/auth.service';
import { ModalTerminalSelectComponent } from '../../modal-terminal-select/modal-terminal-select.component';
import { ModalBranchSelectComponent } from '../../modal-branch-select/modal-branch-select.component';
import { ApiService } from '../../shared/service/api.service';

@Component({
  standalone: true,
  selector: 'app-menu',
  imports: [
    PoToolbarModule,
    CommonModule,
    PoToolbarModule,
    PoMenuModule,
    PoPageModule,
    PoMenuModule,
    ModalTerminalSelectComponent,
    ModalBranchSelectComponent,
    RouterOutlet
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent implements OnInit {
  @ViewChild('modalTerminal', { static: false }) modalTerminal!: ModalTerminalSelectComponent;
  @ViewChild('modalBranch', { static: false }) modalBranch!: ModalBranchSelectComponent;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private tokenService: TokenService,
    private authService: AuthService
  ) { }

  profile: PoToolbarProfile = {
    avatar: '',
    subtitle: '',
    title: ''
  };

  profileActions: Array<PoToolbarAction> = [
    { icon: 'an an-gear', label: 'Trocar Empresa', action: () => { this.modalBranch.open() } },
    { icon: 'an an-gear', label: 'Trocar Terminal', action: () => { this.modalTerminal.open() } },
    { icon: 'an an-sign-out', label: 'Sair', type: 'danger', action: () => { this.logout() }, separator: true }
  ];

  menus: Array<PoMenuItem> = [];
  result: { link: string | null, componentCode: string | null }[] = [];
  logo: string = '/assets/images/logo-totvs-azul_menu.png';

  ngOnInit(): void {
    this.updateProfile();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateProfile();
      }
    });
  }

  updateProfile(): void {
    const username = this.tokenService.getUsername();
    const branchName = this.tokenService.getBranchName();
    const token = this.tokenService.getTokenV2() ?? '';
    const isTokenValid = this.tokenService.isNotExpiredToken(token);

    if (username && isTokenValid) {
      this.profile.title = username;
      this.profile.subtitle = branchName || '';

      if (this.tokenService.getBranch()) {
        const data = this.recoverMenu();
        this.menus = data;
        this.result = [];

        data.forEach((item: any) => this.extractComponent(item));
      }
    } else {
      this.profile.title = '';
      this.profile.subtitle = '';
      this.menus = [];
    }
  }

  extractComponent(item: any) {
    if (item.link && item.componentCode) {
      this.result.push({ link: item.link, componentCode: item.componentCode });
    }

    if (item.subItems) {
      item.subItems.forEach((subItem: any) => this.extractComponent(subItem));
    }

    this.tokenService.saveComponentCode(this.result);
  }

  recoverMenu() {
    const menus = this.tokenService.getItem('menus');
    const parsed: any[] = JSON.parse(menus || '[]');

    return parsed;
  }

  reloadAfterChange(terminal: any) {
    if (this.router.url != "/home") {
      window.location.reload();
    }
  }

  logout() {
    this.authService.logout();
  }
}